import { useSelector } from "react-redux";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import { SwitchProvider } from "shared/dynamic-imports";
import InsightType from "shared/ui-basics/ui-components/InsightType";

export default function InsightTypeDropdown({ object, link, unlink, isSwitchDisabled }) {
	const allInsightTypes = useSelector((state) => state.libraries.insightTypes) || [];
	const linkedIds= object ;
	const linkedInsightTypes = allInsightTypes?.filter((it) => linkedIds?.includes(it?.id));

	const renderReadOnlyItems = () => (
		<>
			{linkedInsightTypes?.map((it) => (
				<div key={it?.id}>
					<InsightType object={it} />
				</div>
			))}
		</>
	);

	const params = {
		selected: linkedInsightTypes,
		options: allInsightTypes,
		renderSelectedItem: (type) => <InsightType key={type?.id} object={type} isEdit={true} handleRemove={unlink} />,
		renderMenuItem: ({ item }) => <InsightType object={item} />,
        linkMenuItem: ({ item, close }) => {
            close()
            link(item.id)
        },
		filter: ({ query, option }) => {
			const it = allInsightTypes.find((s) => s.id === option?.id);
			if (it && !linkedInsightTypes.map((li) => li?.id)?.includes(option?.id)) return it?.name?.toLowerCase().includes(query?.toLowerCase());
		},
	};

	return (
		<SwitchProvider isDisabled={isSwitchDisabled}>
			<EditModeSwitch addLabel="ADD_INSIGHT_TYPE" renderReadOnlyItems={renderReadOnlyItems} isEmpty={linkedInsightTypes?.length === 0} isDisabled={isSwitchDisabled}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
}
